/**
 * Couleurs pastel par statut de dossier
 * Ordre exact à respecter dans le Kanban
 */

export const statusColors: Record<string, string> = {
  "Supprimé": "#F3F3F3",
  "Rejeté": "#FEE2E2",
  "Non traité": "#E0E7FF",
  "Standby": "#DEDEFF",
  "Devis envoyé": "#FEF3C7",
  "Signé": "#DCFCE7",
  "Acompte reçu": "#BBF7D0",
  "Versement complet": "#A7F3D0",
  // Anciens statuts conservés pour rétrocompatibilité DB et imports historiques.
  "À relancer ce jour": "#FFEDD5",
  "À relancer": "#FFEDD5",
  "Déjà relancé": "#FDE68A",
};

/**
 * Liste des statuts dans l'ordre du pipeline commercial
 * Cet ordre doit être respecté partout (Kanban, dropdowns, exports)
 */
export const orderedStatuses = [
  "Supprimé",
  "Rejeté",
  "Non traité",
  "Standby",
  "Devis envoyé",
  "Signé",
  "Acompte reçu",
  "Versement complet",
] as const;

export type CaseStatus = typeof orderedStatuses[number];
